import { createDecorator } from '../../instantiation/common/instantiation.js';
export const IEnvironmentService = createDecorator('environmentService');
//# sourceMappingURL=environment.js.map